import React from 'react';
import styles from './index.module.scss';

// 生成随机高度的函数
const getRandomHeight = (min: number = 20, max: number = 40): string => {
  const randomHeight = Math.floor(Math.random() * (max - min + 1)) + min;
  return `${randomHeight}px`;
};

// 生成随机行数的函数
// const getRandomRowCount = (min: number = 10, max: number = 15): number => {
//   return Math.floor(Math.random() * (max - min + 1)) + min;
// };

// 生成每行骨架图数量的函数
const getRandomItemCount = (min: number = 1, max: number = 3): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

interface SkeletonProps {
  shape?: 'rect' | 'circle';
  width?: string;
  height?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({
  shape = 'rect',
  width = '100%',
  height = '20px',
  className = '',
  style = {},
}) => {
  const skeletonClass = `${styles.skeleton} ${styles[shape]} ${className}`;
  return (
    <div
      className={skeletonClass}
      style={{ width, height, ...style }}
    />
  );
};

interface SkeletonLoaderProps {
  shape?: 'rect' | 'circle';
  width?: string;
  className?: string;
  style?: React.CSSProperties;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  shape = 'rect',
  width = '100%',
  className = '',
  style = {},
}) => {
  const rows = Array.from({ length: 13 }).map(() => getRandomItemCount());

  return (
    <div>
      {rows.map((itemCount, rowIndex) => {
        // 每行的高度是相同的，且为随机值
        const rowHeight = getRandomHeight();

        return (
          <div key={rowIndex} className={styles.row}>
            {Array.from({ length: itemCount }).map((_, index) => (
              <Skeleton
                key={index}
                shape={shape}
                width={width}
                height={rowHeight} // 同一行高度一致
                className={className}
                style={style}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default SkeletonLoader;
